import { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import { useIntercom } from "react-use-intercom";
import SideBar from "../Sections/SideBar";
import TransactionHistory from "./TransactionHistory";
import Navbar from "../Sections/NavBar";
import MobileNav from "../Sections/MobileNav";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../app-store/userSlice";
import UserNotActivated from "../UserNotActivated";
import httpClient from "../../custom-hooks/httpClient";
import Badge from "./Badge";
import { isCommissionWallet } from "../Transfers/OtherWallet/InitiateTransfer";
import EyeOpen from "../Icons/EyeOpen";
import EyeClose from "../Icons/EyeClose";

function Dashboard() {
  const userId = localStorage.getItem("id");

  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();

  const { boot } = useIntercom();
  const [showBalances, setShowBalances] = useState({});

  const toggleBalanceVisibility = (walletId) => {
    setShowBalances((prev) => ({
      ...prev,
      [walletId]: !prev[walletId],
    }));
  };

  useEffect(() => {
    httpClient
      .get(`/users/${userId}`)
      .then(({ status, data }) => {
        if (status === 200) {
          dispatch(setUser(data.user));
          boot({
            name: `${data.user.first_name} ${data.user.last_name}`,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        // toast.error("Error getting user");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!user) {
    return (
      <div
        className="text-center align-items-center"
        style={{ marginTop: "25%" }}
      >
        <Loader type="Oval" color="#1c743a" />
      </div>
    );
  }

  // Handle yet to be activated users
  if (!user.hasOwnProperty("wallets") || !user.wallets.length) {
    return <UserNotActivated />;
  }

  const NIN_REQUEST_STATUS = {
    pending: "secondary",
    processing: "info",
    approved: "primary",
    declined: "danger",
  };
  const ninBadgeProps = {
    theme:
      NIN_REQUEST_STATUS[user.nin_verification_status] || (user.nin ? "primary" : "warning"),
    text: `NIN ${(
        user.nin_verification_status || (user.nin ? "approved" : "Not Submitted")
      ).charAt(0).toUpperCase() + (
        user.nin_verification_status || (user.nin ? "approved" : "Not Submitted") ).slice(1)
    }`,
  };

  return (
    <>
      <Navbar dashboard />
      <MobileNav />
      <section>
        <div className="container-fluid">
          <div className="row">
            <SideBar user={user} />
            <div className="col-12 col-lg-9 offset-lg-3 offset-xl-2 py-7 py-lg-9 px-lg-9">
              <h1 className="mb-1" id="alerts">
                Welcome, {user.first_name} <Badge {...ninBadgeProps} />
              </h1>

              <div className="row py-5">
                {user.wallets.map((wallet) => (
                  <div className="col-xl-4 col-md-4 mb-4" key={wallet.id}>
                    <div
                      className={`card shadow-lg card-border card-border-xl ${
                        wallet.account_status === "blocked"
                          ? "border-danger"
                          : "border-primary"
                      }`}
                    >
                      <div className="card-body">
                        <div className="text-center mb-3">
                          <p className="h3">{wallet.name}</p>
                          <span
                            className={`badge rounded-pill ${
                              wallet.account_status === "blocked"
                                ? "bg-danger-soft"
                                : "bg-primary-soft"
                            }`}
                          >
                            <span className="h6 text-uppercase mb-2">
                              {wallet.account_status}
                            </span>
                          </span>
                          {/* <p className="mt-2">Tier 1</p> */}
                        </div>
                        <div className="d-flex justify-content-center align-items-center">
                          {showBalances[wallet.id] && (
                            <span className="h3 mb-0 me-1">₦</span>
                          )}
                          <span className="price h3 mb-0 fw-bold">
                            {showBalances[wallet.id]
                              ? Number(wallet.balance)
                                  .toFixed(2)
                                  .toLocaleString()
                              : "• • • •"}
                          </span>
                          <span
                            className="ms-2"
                            onClick={() => toggleBalanceVisibility(wallet.id)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter")
                                toggleBalanceVisibility(wallet.id);
                            }}
                            aria-label="Toggle balance visibility"
                            role="button"
                            tabIndex="0"
                            title={
                              showBalances[wallet.id]
                                ? "Hide Balance"
                                : "Show Balance"
                            }
                          >
                            {showBalances[wallet.id] ? (
                              <EyeOpen
                                width="20"
                                height="20"
                                className="mt-n1"
                              />
                            ) : (
                              <EyeClose width="20" height="20" />
                            )}
                          </span>
                        </div>

                        <p className="text-center text-primary">
                          {isCommissionWallet(wallet.product_id)
                            ? "N/A"
                            : wallet.account_no}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <hr className="bg-gray-300 my-6" />

              <TransactionHistory wallets={user.wallets} />
            </div>
            <div className="col-12 col-lg-3 col-xl-2 d-none d-lg-block px-lg-0 sidenav sidenav-end"></div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Dashboard;
